import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=3bdd9568&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=3bdd9568&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd9568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bdd9568')) {
      api.createRecord('3bdd9568', component.options)
    } else {
      api.reload('3bdd9568', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=3bdd9568&scoped=true", function () {
      api.rerender('3bdd9568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/context-menu/ContextMenu.vue"
export default component.exports